import { useGetGroupsQuery } from "../features/groups/groupsApiSlice";
import { Listbox } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faChevronDown } from "@fortawesome/free-solid-svg-icons";

const GroupsCheckbox = ({ groupsIds, setGroupsIds }) => {
  const {
    data: groups,
    isLoading,
    isSuccess,
    isError,
  } = useGetGroupsQuery("groupsList", {
    refetchOnMountOrArgChange: true,
  });

  if (isLoading || isError) return null;

  const { entities } = groups || {};
  const arrGroups = Object.values(entities || {});

  return (
    <div className="flex-1">
<div className="min-w-[16rem] w-fit max-w-full">
        <Listbox value={groupsIds} onChange={setGroupsIds} multiple>
          <div className="relative">
            {/* כפתור הבחירה */}
            <Listbox.Button
              className="w-full min-h-[40px] max-h-[120px] overflow-y-auto cursor-default rounded-lg bg-white py-2 pr-8 pl-3 text-right shadow-md focus:outline-none"
            >
              <span className="block text-right text-base whitespace-normal break-words">
                {groupsIds.length > 0
                  ? arrGroups
                      .filter((g) => groupsIds.includes(g._id))
                      .map((g) => g.name)
                      .join(", ")
                  : "בחר קבוצות"}
              </span>
              <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                <FontAwesomeIcon
                  icon={faChevronDown}
                  className="h-4 w-4 text-gray-400"
                />
              </span>
            </Listbox.Button>

            {/* רשימת האפשרויות */}
            <Listbox.Options
              className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none z-10"
            >
              {arrGroups.map((group) => (
                <Listbox.Option
                  key={group._id}
                  value={group._id}
                  className={({ active }) =>
                    `relative cursor-pointer select-none py-2 pr-10 pl-4 ${
                      active ? "bg-blue-100 text-blue-900" : "text-gray-900"
                    }`
                  }
                >
                  {({ selected }) => (
                    <>
                      <span
                        className={`block truncate text-right ${
                          selected ? "font-medium" : "font-normal"
                        }`}
                      >
                        {group.name}
                      </span>
                      {selected && (
                        <span className="absolute inset-y-0 right-0 flex items-center pr-3 text-blue-600">
                          <FontAwesomeIcon icon={faCheck} className="h-3.5 w-3.5" />
                        </span>
                      )}
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </div>
        </Listbox>
      </div>
    </div>
  );
};

export default GroupsCheckbox;